export default "__VITE_ASSET__c3188c68__"